import React, { Component } from 'react';
import {Link} from 'react-router-dom';
import '../App.css';

import EndOfProject from './EndOfProject';

import user_icon from '../Images/user-icon.svg';
import code_icon from '../Images/code-icon.svg';
import pencil_icon from '../Images/pencil-icon.svg';
import arrow_icon from '../Images/arrow-icon.svg';
import cards_icon from '../Images/cards-icon.svg';
import shopping_icon from '../Images/shopping-icon.svg';
import qr_icon from '../Images/qr-icon.svg';
import sparkle_icon from '../Images/sparkle-icon.svg';

import projectad from '../Images/project-ad.jpg';
import ad1 from '../Images/ad1.jpg';
import ad2 from '../Images/ad2.jpg';
import ad3 from '../Images/ad3.jpg';
import ad4 from '../Images/ad4.jpg';
import ad6 from '../Images/ad6.jpg';
import ad11 from '../Images/ad11.jpg';
import ad15 from '../Images/ad15.jpg';
import ad16 from '../Images/ad16.jpg';
import ad17 from '../Images/ad17.jpg';
import ad18 from '../Images/additive-drinking-screens.jpg';
import ad19 from '../Images/additive-drinking-cards.jpg';

class ProjectAdditiveDrinking extends Component {
  
    constructor(props) {
        super();
        this.props = props;
    }
  
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  componentWillUnmount(){

  }

  visitWebsite() {
    window.open("https://additivedrinking.com", "_blank");
  }

  render () {
    
    const footerYear = new Date().getUTCFullYear();

    return (
        
      <div id="project">

        <div className="project-content-top">
          
            <p className="project-title-large">Additive Drinking: A Card Game and E-Commerce Website</p>
            <img className="project-image-rounded-2" src={projectad} alt=""></img>

            <div className="project-text-container">
              <p className="project-text-medium">Summary</p>
            </div>
            <div className="project-overview">
              <div className="project-overview-left">
                <div className="project-text-container-2">
                  <p className="project-text-small">Mission</p>
                  <p className="project-paragraph">I invented a card game during my college days with friends, and later developed an online store for selling professionally printed copies. To share the game with interested buyers, I launched a Kickstarter where it was backed and distributed to people all around the world. </p>
                </div>
                <div className="project-text-container-2">
                  <p className="project-text-small">My Contributions</p>
                  <p className="project-paragraph">After several play-throughs and iterations, I created a professionally packaged game, and a website developed in React for marketing, purchasing, and viewing the game's instructions.</p>
                </div>
              </div>
              <div className="project-overview-right">
                <div className="project-text-container-3">
                  <p className="project-text-small">Link</p>
                  <div className="button" onClick={(e) => {this.visitWebsite()}}>
                    <p>AdditiveDrinking.com</p>
                    <img className="button-icon" src={arrow_icon} alt=""></img>
                  </div>
                </div>

                <div className="project-text-container-3">
                  <p className="project-text-small">My Tasks</p>

                  <div className="icon-bullet">
                    <img className="bullet-icon" src={cards_icon} alt=""></img>
                    <p className="project-paragraph">Game Creation</p>
                  </div>
                  <div className="icon-bullet">
                    <img className="bullet-icon" src={code_icon} alt=""></img>
                    <p className="project-paragraph">Web Programming</p>
                  </div>
                  <div className="icon-bullet">
                    <img className="bullet-icon" src={pencil_icon} alt=""></img>
                    <p className="project-paragraph">UX Design</p>
                  </div>
                  <div className="icon-bullet">
                    <img className="bullet-icon" src={user_icon} alt=""></img>
                    <p className="project-paragraph">Play Testing</p>
                  </div>
                </div>

              </div>
            </div>
        </div>

        <div className="project-content">
          
          <div className="project-chunk">
            <div className="project-text-container">
              <p className="project-text-medium">The Product</p>
              <p className="project-paragraph">The game includes 61 playing cards including 1 instructional QR card linking to the game's instructions. The card game doubles as a drinking game that will challenge your friends' drinking abilities in competitive fun.</p>
            </div>
            <div className="trio-container">
              <div className="trio-item">
                <p className="project-bold-text">Category</p>
                <p className="project-subtext">Card Game</p>
              </div>
              <div className="trio-item">
                <p className="project-bold-text">Number of Cards</p>
                <p className="project-subtext">61</p>
              </div>
              <div className="trio-item">
                <p className="project-bold-text">Age Restriction</p>
                <p className="project-subtext">21+</p>
              </div>
            </div>
            <img className="project-image-nobordered" src={ad17} alt=""></img>
          </div>

          <div className="project-chunk">
            <div className="project-text-container">
              <p className="project-text-medium">The Kickstarter</p>
              <p className="project-paragraph">The Kickstarter campaign launched in October 2020 with a funding goal of $500. In November, the goal was reached and I supplied a professionally packaged game to all Kickstarter backers.</p>
            </div>
            <div className="trio-container">
              <div className="trio-item">
                <p className="project-bold-text">Delivery Date</p>
                <p className="project-subtext">Dec 2020</p>
              </div>
              <div className="trio-item">
                <p className="project-bold-text">Funding Goal</p>
                <p className="project-subtext">$500</p>
              </div>
              <div className="trio-item">
                <p className="project-bold-text">Backers</p>
                <p className="project-subtext">24</p>
              </div>
            </div>
            <img className="project-image-bordered" src={ad1} alt=""></img>
          </div>

          <div className="project-chunk">
            <div className="project-text-container">
              <p className="project-text-medium">Programming the Website</p>
              <p className="project-paragraph">I designed and developed a website in React to handle the following functionality:</p>
              <div className="icon-bullet">
                <img className="bullet-icon" src={shopping_icon} alt=""></img>
                <div>
                  <p className="project-bold-text">Purchasing Capabilities</p>
                  <p className="project-subtext">The PayPal API allows users to purchase the game online using their credit card or PayPal account.</p>
                </div>
              </div>
              <div className="icon-bullet">
                <img className="bullet-icon" src={qr_icon} alt=""></img>
                <div>
                  <p className="project-bold-text">The Game's Instructions</p>
                  <p className="project-subtext">A QR Code included with the game links the player to the website where they can read the game's instructions.</p>
                </div>
              </div>
              <div className="icon-bullet">
                <img className="bullet-icon" src={sparkle_icon} alt=""></img>
                <div>
                  <p className="project-bold-text">Promotional Content</p>
                  <p className="project-subtext">The homepage serves to market the game to prospective customers, funneling them to purchase the game using well-placed CTAs. </p>
                </div>
              </div>
            </div>
            <img className="project-image-bordered" src={ad18} alt=""></img>
          </div>

          <div className="project-chunk">
            <div className="project-text-container">
              <p className="project-text-medium">The QR Code Experience</p>
              <p className="project-paragraph">I consolidated the game's instructions into a playing card that fits nicely in the box with the other cards. This reduced the need to print extra paper and is less hassle for the player to deal with. Scanning the code takes you to the website for a more personal viewing of the instructions.</p>
            </div>
            <img className="project-image-nobordered" src={ad16} alt=""></img>
          </div>

          <div className="project-chunk">
            <div className="project-text-container">
              <p className="project-text-medium">Card Design</p>
              <p className="project-paragraph">Beer cards have a drinking task and a point value corresponding to the tasks' difficulty level. The background art depicts a rising quantity of beer such that tasks that require more drinking have more of the beer artwork. </p>
            </div>
            <img className="project-image-bordered" src={ad19} alt=""></img>
          </div>

          <div className="project-chunk">
            <div className="project-text-container">
              <p className="project-text-medium">3D Marketing Media</p>
              <p className="project-paragraph">I used Blender to create 3D models and animations to use in marketing media. The scenes below capture a simulation of the playing and drinking experience.</p>
            </div>
            <img className="project-image-nobordered" src={ad3} alt=""></img>
            <img className="project-image-nobordered" src={ad11} alt=""></img>
          </div>
  
          <EndOfProject/>

        </div>
                
      </div>
    );
  }
}

export default ProjectAdditiveDrinking;
